<div>
    @if (addingEditingMode === false) {
        <div>
            <div class="flex justify-content-between align-items-center gap-3 mb-3">
                <h2 class="section-title m-0">{{ 'settings.entity.title' | translate }}</h2>
                @if (canAddEntities) {
                    <p-button
                        [label]="'settings.entity.addYear' | translate"
                        icon="ms ms-add"
                        (onClick)="addEditEntity()" />
                }
            </div>
            @if (!isLoading && pricingPlan && entities) {
                <p>
                    {{
                        'settings.entity.remaining'
                            | translatePlural: pricingPlan.licenseDoc.max_entities - entities.length
                            | translate
                                : {
                                      actual: entities.length,
                                      max: pricingPlan.licenseDoc.max_entities,
                                      remaining: pricingPlan.licenseDoc.max_entities - entities.length,
                                  }
                    }}
                </p>
            }
            <div class="card">
                <p-table
                    [value]="entities"
                    [loading]="isLoading"
                    [showLoader]="false"
                    [paginator]="true"
                    [alwaysShowPaginator]="false"
                    [rows]="10">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 30%" pSortableColumn="name">
                                {{ 'settings.entity.name' | translate }}
                                <p-sortIcon field="name" />
                            </th>
                            <th style="width: 15%" pSortableColumn="country">
                                {{ 'settings.entity.country' | translate }}
                                <p-sortIcon field="country" />
                            </th>
                            <th style="width: 35%">
                                {{ 'settings.entity.industry' | translate }}
                            </th>
                            <th class="col-number" style="width: 10%" pSortableColumn="employeesCount">
                                <p-sortIcon field="employeesCount" />
                                {{ 'settings.entity.employees' | translate }}
                            </th>
                            <th class="col-actions"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-entity>
                        <tr>
                            <td class="font-medium">{{ entity.name }}</td>
                            <td>{{ 'countries.' + entity.country | translate }}</td>
                            <td>{{ getIndustryDisplay(entity.industryId) }}</td>
                            <td class="col-number">{{ entity.employeesCount }}</td>
                            <td class="col-actions">
                                <p-button
                                    icon="ms ms-edit"
                                    [text]="true"
                                    [rounded]="true"
                                    size="small"
                                    [ariaLabel]="'components.settingsForm.button.edit' | translate"
                                    [pTooltip]="'components.settingsForm.button.edit' | translate"
                                    (onClick)="addEditEntity(entity)" />
                            </td>
                        </tr>
                    </ng-template>
                    <!-- First load: skeleton rows shaped like the entity rows -->
                    <ng-template pTemplate="loadingbody">
                        @for (row of [1, 2, 3]; track row) {
                            <tr>
                                <td><p-skeleton width="60%" /></td>
                                <td><p-skeleton width="50%" /></td>
                                <td><p-skeleton width="70%" /></td>
                                <td class="col-number"><p-skeleton width="2rem" styleClass="ml-auto" /></td>
                                <td class="col-actions"></td>
                            </tr>
                        }
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="5">
                                <div class="empty-state empty-state--compact">{{ 'common.noData' | translate }}</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    } @else {
        <app-edit-entity
            [organizationId]="organizationId"
            [entity]="selectedEntity"
            [cities]="countryCitiesLUT"
            [industries]="industries"
            [activeQuestionnaire]="activeQuestionnaire"
            [entities]="entities"
            [currencies]="currencies"
            [availableYears]="yearsWithData"
            (closeEditEntity)="onCloseEditEntity($event)"></app-edit-entity>
    }
</div>
